import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lp2-private-class-thank-you-modal',
  templateUrl: './private-class-thank-you-modal.component.html',
  styleUrls: ['./private-class-thank-you-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivateClassThankYouModalComponent {
  constructor(public activeModal: NgbActiveModal) {}
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/private-class-banner/private-class-thank-you-modal/private-class-thank-you-modal.component.ts